import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { deepPurpleMui, greyMui } from "@ryde/theme";

export const LiveMapViewSwitchStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "live-map-view-switch",
})`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${greyMui._300};
  border-radius: 8px;
  padding: 2px;
  gap: 2px;
  background-color: ${greyMui._100};
  flex-shrink: 0;

  .live-map-view-switch__option {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-height: 28px;
    padding-inline: 8px;
    border-radius: 6px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    color: ${greyMui._600};
    white-space: nowrap;

    &.is-active {
      background-color: white;
      color: ${deepPurpleMui.A700};
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
    }

    .live-map-view-switch__icon {
      width: 20px;
      height: 20px;
      display: block;
      flex-shrink: 0;
    }
  }
`;
